<template>

    <form ref="colaborador-form-add-escola-cargo" v-on:submit.prevent="salvarColaboradorEscolaCargo(model)" novalidate>

        <div class="row">
            <section class="col-md-12">
                <div class='form-group'>
                    <label class="labelNegrito">Nome do Colaborador:</label>
                    <span style="padding-left:10px;">{{colaboradorId}} - {{colaborador}}</span>
                </div>
            </section>
        </div>
        <div class="row">
            <section class="col-md-12">
                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th title="Escola" style="text-align:center;">Escola </th>
                                <th style="text-align:center;">Cargo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" class="animated fadeIn">
                                <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 30ch; overflow: hidden; text-align:center;">                                   
                                        <span v-for="item2 in item.collectionColaboradorEscolaAtiva" v-bind:key="item2.escolaId" name="nmescolas" @mouseover="colaboradorIdHover = item2.colaboradorId; escolaIdHover = item2.escolaId" @mouseleave="escolaIdHover = 0">
                                            {{ item2.escola.nomeEscola }}<br />
                                        </span> 
                                </td>
                                <td style="text-align:center;">
                                    <span v-for="item3 in item.collectionColaboradorEscolaAtiva">
                                        <span v-for="item4 in item3.collectionColaboradorEscolaCargo" v-bind:key="item3.cargoId" name="nmcargos" :class="{destaca : colaboradorIdHover == item4.colaboradorId && escolaIdHover == item4.escolaId }">
                                            {{ item4.cargo.dsCargo }}<br />
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <div class="row">
            <section class="col-md-12">
                <div class="col-md-12">
                    <span>&nbsp;</span>
                </div>
            </section>
        </div>
        <div class="row">
            <section class="col-md-6">
                <div class='form-group'>
                    <label class="labelNegrito">Selecione uma escola:</label>
                    <!--<select v-select="{ dataitem: 'Escola', default: 'Selecione uma escola', filters: { attributeBehavior: 'escolaColaboradorFranqueado', ColaboradorId: 56 } }" class="form-control" name="escolaId" id="escolaId" @change="trocandoEscola" v-model="filter.escolaId" required></select>-->
                    <select class="form-control" name="escolaId" id="escolaId" @change="trocandoEscola" v-model="filter.escolaId" required>
                        <option value="">Selecione uma escola</option>
                        <option v-for="item in result.escolas" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </section>
            <section class="col-md-6">
                <div class='form-group'>
                    <label class="labelNegrito">Selecione um cargo:</label>
                    <div v-if="cargoPorEscola">
                        <!--<select v-select="{ dataitem: 'Cargo', filters: { attributeBehavior: 'CargoHierarquiaEspecificosEscola', escolaId:filter.escolaId, colaboradorId: colaboradorId} }" class="form-control" v-model="filter.cargoId" name="cargoId" required></select>-->
                        <select class="form-control" v-model="filter.cargoId" name="cargoId" required>
                            <option value="">Selecione um cargo</option>
                            <option v-for="item in result.cargos" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </option>
                        </select>
                    </div>
                    <div v-if="!cargoPorEscola">
                        <select class="form-control" name="escolaCargoId" disabled required><option value="">Selecione um cargo</option></select>                        
                    </div>
                    <div style="color:#ff0000" v-if="cargoNaoDisponivel">Não existe cargos disponíveis para a escola selecionada!</div>
                </div>
            </section>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="salvarColaboradorEscolaCargo(model)" :disabled="EhSalvar?disabled:''">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import auth from '@/common/auth'

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import Cache from '@/common/cache'


    export default {
        name: "colaborador-form-add-escola-cargo",
        mixins: [base],
        props: { colaboradorId: Number, colaborador: String},
        data: () => ({
            nivelSenha: 0,
            model: {},
            cargoPorEscola: false,
            escolaIdHover: 0,
            colaboradorIdHover: 0,
            usuarioLogado: 0,
            cargoNaoDisponivel: false,
            EhSalvar: false,
            form: "colaborador-form-add-escola-cargo",

            resources: {
                edit: 'colaborador',
            },

            filter: {
                cargoId: "",
                escolaId: ""
            },

            result: {              
                items: [],
                cargos: [],
                escolas: []
            }

        }),

        methods: {

            executeEdit: function (model) {
                model.attributeBehavior = "AlterarSenha"
                model.colaboradorId = this.colaboradorId;
                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Senha alterada com sucesso");
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            //Task-1867
            trocandoEscola: function () {
                this.filter.cargoId = "";                
                //this.cargoPorEscola = false;                 
                this.carregaComboCargo();
                //console.log("cargos do objeto..........:",this.cargos);
                //if (this.filter.escolaId) {
                //    setTimeout(() => { this.cargoPorEscola = true; }, 1000);                    
                //    console.log("codigo da escola....:", this.filter.escolaId);
                //}
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

            verificaSenha: function () {
                this.nivelSenha = 0;

                var temLetra = /([a-z])/.test(this.model.senhaMD5);
                var temEspecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(this.model.senhaMD5);
                var temNumero = /\d/.test(this.model.senhaMD5);

                if (this.model.senhaMD5.length < 6) {
                    this.nivelSenha++;
                    return
                }

                if (temLetra) this.nivelSenha++;
                if (temEspecial) this.nivelSenha++;
                if (temNumero) this.nivelSenha++;
            }
            ,
            //Task-1868
            carregaComboCargo: function () {
                new Api('Cargo/DataItems').get({ colaboradorId: this.colaboradorId, escolaId: this.filter.escolaId, attributeBehavior: "CargoHierarquiaEspecificosEscola" }).then(data => {
                    if (data.dataList.length > 0) {
                        this.result.cargos = data.dataList;
                        this.cargoPorEscola = true;
                        this.cargoNaoDisponivel = false;
                        this.EhSalvar = true;
                    }
                    else {
                        this.result.cargos = [];
                        this.cargoPorEscola = false;
                        this.cargoNaoDisponivel = true;
                        this.EhSalvar = false;
                    }

                    //console.log("cargos.............:", this.result.cargos);
                }, err => {
                    this.defaultErrorResult(err);
                });
            },
            carregaComboEscola: function () {//@TASK_14818
                new Api('Escola/DataItems').get({ colaboradorId: this.usuarioLogado, attributeBehavior: "escolaColaboradorFranqueado" }).then(data => {
                    if (data.dataList.length > 0) {
                        this.result.escolas = data.dataList;
                        //this.cargoPorEscola = true;
                    }
                    else {
                        this.result.escolas = [];
                        //this.cargoPorEscola = false;
                    }

                    //console.log("Escolas .............:", this.result.escolas);
                }, err => {
                    this.defaultErrorResult(err);       
                });
            },

            salvarColaboradorEscolaCargo: function (model) {
                if (this.formValidate() == false)
                    return;

                this.model={
                    colaboradorId: this.colaboradorId,
                    escolaId: this.filter.escolaId,
                    cargoId: this.filter.cargoId,
                    attributeBehavior:"SaveAddEscolaCargo"
                };
                //console.log("model...........:",this.model);
                new Api("colaboradorescolacargo/salvarColaboradorEscolaCargo").post(this.model).then(data => {
                    this.$emit('on-saved', data.data);
                    this.defaultSuccessResult("Cargo Atribuído com Sucesso");                                   
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
        },
        mounted() {
            new Api('colaborador').get({ colaboradorId: this.colaboradorId, attributeBehavior: "ListagemColaboradoresCargos" }).then(data => {

                console.log("Colaborador.........: ", this.colaboradorId);

                if (data.dataList.length == 1) {
                    this.model = data.dataList;
                    this.result.items = data.dataList;
                }
                //console.log("dados.............:", this.model, " id", this.colaboradorId);
            }, err => {
                this.defaultErrorResult(err);
            });

            this.usuarioLogado = auth.currentUser().sub;
            

            //console.log("usuario logado.", this.usuarioLogado);

            //console.log("dados.......:", this.result.items);

            this.carregaComboEscola();
        }
    };
</script>
<style>
    .labelNegrito{
        font-weight:bold;
    }
    span[name=nmescolas]:hover {
        background-color: #ffd800;
        font-weight: bold;
    }

    .destaca {
        font-weight: bold;
        background-color: #ffd800;
    }
</style>